/**
 * Non international-safe case insensitive comparison of a needle to a haystack
 *
 * @param {string} needle
 * @param {array|string} haystack Can be a string or an array
 */
export default function(needle, haystack) {
    needle = needle.toString().toUpperCase();
    if (Array.isArray(haystack)) {
        for (let index = 0, len = haystack.length; index < len; index++) {
            if (haystack[index].toString().toUpperCase() == needle) {
                return true;
            }
        }
        return false;
    }
    if (haystack.toString().toUpperCase() == needle) {
        return true;
    }
    return false;
}